module.exports = __webpack_public_path__ + "static/media/advance.1cf6c973.png";